export default "__VITE_ASSET__1c8E_8lO__"